import { render, staticRenderFns } from "./UpdatePlanModal.vue?vue&type=template&id=2d2f7a87&"
import script from "./UpdatePlanModal.vue?vue&type=script&lang=js&"
export * from "./UpdatePlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports